
<div class="flex-column">
  <div class="text-center">
    <h2 style="color: var(--verde);" >Hola! Te pedimos los datos necesarios para que obtengas tu cotización.</h2>
  </div>
  <div class="text-center">

    <mat-stepper [linear]="isLinear" #stepper class="margen_superior">
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup" autocomplete="off">
          <ng-template matStepLabel>Datos Profesionales</ng-template>
          <h3 style="color: var(--azul);">Ingresa tus datos Profesionales y selecciona la suma asegurada que desees.</h3>
          <div class="col-fixed">
            <mat-form-field class="example-full-width" style="margin-top: 20px;">
              <mat-label>
                Especialidad
              </mat-label>
              <mat-select formControlName="especialidadControl"
                  (selectionChange)="onOptionSelected($event)">
                <mat-option *ngFor="let especialidad of especialidades" [value]="especialidad.codigo">{{especialidad.descripcion}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <div *ngIf="vet_sub.length > 0">
              <mat-form-field class="example-full-width">
                <mat-label>
                  Tipo de Animales
                </mat-label>
                <mat-select
                  (selectionChange)="cambioVet($event)"
                  formControlName = "tipoAnimalesControl"
                >
                  <mat-option *ngFor="let item of vet_sub" value="{{item.codigo}}">{{item.descripcion}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>
                Tipo Matrícula
              </mat-label>
              <mat-select formControlName="tipoMatriculaControl">
                <mat-option *ngFor="let item of matriculas" value="{{item.tipo_matricula_id_smg}}">{{item.tipo_matricula_descripcion}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>
                Matrícula
              </mat-label>
              <input matInput type="number" formControlName="matriculaControl" >
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>
                Título
              </mat-label>
              <input matInput type="text" formControlName="tituloControl" placeholder="Titulo según indica el diploma.">
            </mat-form-field>
          </div>

          <div class="col-fixed">

            <mat-slide-toggle
                class="example-margin slide-margin"
                (change)="onToggleChange('jefe', $event.checked)"
                [checked]="checkedJefe"
                >
              Soy Jefe
            </mat-slide-toggle>

            <mat-slide-toggle
                class="example-margin slide-margin"
                (change)="onToggleChange('director', $event.checked)"
                [checked]="checkedDirector"
                >
              Soy Director
            </mat-slide-toggle>

        </div>

          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>
                Suma Asegurada
              </mat-label>
              <div matPrefix>$</div>
              <!--
              <input matInput
                     formControlName="saControl"
                     type="number"
                     [value]="this.sa?.categorias_praxis_sa_minima | moneda"
                     min="this.sa?.categorias_praxis_sa_minima"
                     max="this.sa?.categorias_praxis_sa_maxima"
                     step="1000000"

                     (keydown)="false">
              -->
              <mat-select formControlName="saControl" placeholder="Seleccionar una suma asegurada dentro del rango.">
                <mat-option *ngFor="let item of numeros" value="{{item}}">
                  {{item.toString() | moneda}}
                </mat-option>
              </mat-select>
              <small>Min: {{this.sa?.categorias_praxis_sa_minima | currency}} - Max: {{this.sa?.categorias_praxis_sa_maxima | currency}}</small>
            </mat-form-field>
          </div>
          <div class="col-fixed button-container-siguiente">
            <button class="button-next-back" mat-button matStepperNext>Siguiente</button>
          </div>
        </form>
      </mat-step>


      <mat-step [stepControl]="secondFormGroup">
        <form class="example-form" [formGroup] = "secondFormGroup" autocomplete="off">
          <ng-template matStepLabel>Datos Personales</ng-template>
          <h3 style="color: var(--azul);">Ahora por favor completa tus datos personales.</h3>
          <div class="col-fixed">
            <mat-form-field class="example-full-width" style="margin-top: 20px;">
              <mat-label>Apellido</mat-label>
              <input matInput formControlName="apellidoControl" autocomplete="new-apellido">
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombreControl" autocomplete="new-nombre">
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>Categoría IVA</mat-label>
              <mat-select formControlName="ivaControl">
                <mat-option *ngFor="let item of iva" value="{{item.codigo}}">{{item.descripcion}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>Código Postal</mat-label>
              <input matInput
                    type="text"
                    (input) = "buscar_cp()"
                    formControlName="cpControl"
                    autocomplete="new-cp"
              >
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>Localidad</mat-label>
              <mat-select (selectionChange)="seleccionar_provincia($event)" formControlName="localidadControl">
                <mat-option *ngFor="let item of localidades" value="{{item.Localidad}}">
                  {{item.Descripcion}}
                </mat-option>

              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>Provincia</mat-label>
              <mat-select [value]="selectedProvincia" formControlName="provinciaControl">
                <mat-option *ngFor="let provincia of provincias" [value]="provincia?.provincia_string_id">{{provincia?.provincia_nombre}}</mat-option>
              </mat-select>

            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>
                Celular
              </mat-label>
              <input matInput type="tel" formControlName="celularControl" autocomplete="new-celular">
            </mat-form-field>
          </div>
          <div class="col-fixed">
            <mat-form-field class="example-full-width">
              <mat-label>
                Correo
              </mat-label>
              <input matInput type="email" formControlName="emailControl" autocomplete="new-email">
            </mat-form-field>
          </div>
          <div class="col-fixed button-container">
            <button class="button-next-back" mat-button matStepperPrevious>Volver</button>
            <button class="button-next-back" mat-button (click)="cotizar()" [disabled]="!secondFormGroup.valid">Cotizar</button>
          </div>
        </form>
      </mat-step>

    </mat-stepper>
  </div>

</div>
